export default __webpack_public_path__ + "static/media/nosso-instituto.3615e23d.png";